import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  DataGrid,
} from '@material-ui/data-grid';
import IconButton from '@material-ui/core/IconButton';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import './DataEntryGrid.scss';
import { useDataEntryGrid } from './useDataEntryGrid';
import { useStyles } from './DataEntryGridTheme';

export const DataEntryTooltip = withStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(14),
    whiteSpace: 'nowrap',
  },
}))(Tooltip);

export const DataEntryGrid = ({
  columns = [],
  data = [],
  editable = false,
  onRowsChange,
  scrolledOnceGrid,
  onScrolledOnce,
  showLastPeriod = true,
}: {
  columns: any[];
  data: any[];
  editable: boolean;
  onRowsChange: any;
  scrolledOnceGrid: any;
  onScrolledOnce: any;
  showLastPeriod?: boolean;
}) => {
  const classes = useStyles();
  const logic = useDataEntryGrid({
    columns,
    data,
    editable,
    onRowsChange,
    scrolledOnceGrid,
    onScrolledOnce,
    showLastPeriod,
  });

  return (
    <React.Fragment>
      {logic.formattedColumns.length <= 5 ? (
        <div className="header-group py-2 d-flex justify-content-around p-header">
          <span>Historical Information</span>
          <span>Current</span>
        </div>
      ) : (
        <div className="header-group py-2 d-flex justify-content-around">
          <span>Historical Information</span>
        </div>
      )}
      <div className="data-entry-grid d-flex">
        <div className="d-flex flex-column" style={{ width: 233 }}>
          <div className="flex-grow-1">
            <div
              style={{
                height: 48,
                backgroundColor: '#f9f9f9',
                borderLeft: '1px solid #ddd',
                borderRight: '1px solid #ddd',
                borderBottom: '1px solid #ddd',
                textAlign: 'right',
              }}
            >
              <IconButton
                ref={logic.arrowLeftRef}
                onClick={logic.scroll}
                style={{
                  marginTop: 6,
                  padding: 8,
                  transition: 'opacity 0.25s ease',
                }}
              >
                <ArrowBackIosIcon style={{ fontSize: 20 }} />
              </IconButton>
            </div>
            {data.map(row => (
              <div
                key={row.id}
                style={{
                  backgroundColor: '#f9f9f9',
                  borderLeft: '1px solid #ddd',
                  borderRight: '1px solid #ddd',
                  borderBottom: '1px solid #ddd',
                  height: 35,
                  lineHeight: 2,
                  padding: '0 5px',
                  textAlign: 'right',
                }}
              >
                <Chip
                  style={{ lineHeight: 1.75 }}
                  label={row.name}
                  className="lens-chip-h"
                />
              </div>
            ))}
          </div>
        </div>
        <div className="flex-grow-1">
          <div ref={logic.el} style={{ height: 400, width: '100%' }}>
            {logic.formattedColumns.length > 0 && (
              <DataGrid
                className={classes.root}
                headerHeight={48}
                rowHeight={35}
                rows={data}
                columns={logic.formattedColumns}
                onEditCellChangeCommitted={logic.handleCellEditCommit}
                disableColumnMenu
                hideFooter
              />
            )}
          </div>
        </div>
        <div
          className="d-flex flex-column"
          style={{ width: 37 }}
          hidden={columns.length < 6}
        >
          <div
            className="flex-grow-1"
            style={{
              borderLeft: '1px solid #ddd',
              borderRight: '1px solid #ddd',
              borderBottom: '1px solid #ddd',
              marginBottom: '17px',
            }}
          >
            <div
              style={{
                height: 48,
                backgroundColor: '#f9f9f9',
                borderBottom: '1px solid #ddd',
              }}
            >
              <IconButton
                ref={logic.arrowRightRef}
                onClick={() => logic.scroll('left')}
                style={{
                  marginTop: 6,
                  padding: 8,
                  transition: 'opacity 0.25s ease',
                }}
              >
                <ArrowForwardIosIcon style={{ fontSize: 20 }} />
              </IconButton>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
